module.exports = __webpack_public_path__ + "static/img/beian.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beian.png
// module id = XNTI
// module chunks = 1